//todo get from cloud-components

const CONTEXT_KEY_RE = /^\.\/(.+)\.(.+)$/;

function parseContextKey(key: string) {
    const match = key.match(CONTEXT_KEY_RE);

    if (match) {
        const [, name, ext] = match;
        return {name, ext};
    }

    return null;
}

export function importContext<T>(context: __WebpackModuleApi.RequireContext) {
    const store = {} as Record<string, T>;

    context.keys().forEach((key) => {
        const keyData = parseContextKey(key);

        if (!keyData) {
            return;
        }

        const module = context(key);
        store[keyData.name] = module.default || module;
    });

    return store;
}
